import React from 'react'
import savingsHabitSuccess from "../../../../../assets/images/savings-habit-done.png"
import { useTranslation } from 'react-i18next'
import { withOidcSecure } from '@axa-fr/react-oidc';
import { useKeyDown } from '../../../../../hooks/useKeyDown';
import { appTheme } from '../../../../../helpers/utils/Utils';
import { useSelector } from 'react-redux';




const Success = ({ content1, btn1, btn1Function, btn2, btn2Function, icon }) => {
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const appThemeData = appTheme(kudzuPlusTrue);
    const { t } = useTranslation();

    useKeyDown(() => {
        btn1Function();
    }, ["Enter"])


    return (
        <div className=' flex flex-col justify-center items-center w-full'>
            <p className='font-hanken-grotesk lg:text-[20px] text-[var(--modal-text-heading-clr)]  md:text-[18px] sm:text-[16px] text-[14px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] md:leading-[28px] text-left w-full'>{content1}</p>
            {icon ?
                <img src={icon} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' />
                :
                <img src={appThemeData.picSuccsess} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' />
            }
            <div className=' flex flex-col justify-center items-center w-full'>

                <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                    <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] 
 sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={() => btn1Function()} onKeyDown={(e) => { if (e.key === "Enter") btn1Function() }}>{btn1}</button>
                    {btn2 &&
                        <button class="font-hanken-grotesk lg:text-[18px] md:text-[17px] 
 sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] text-[var(--modal-btn-text-color)] cursor-pointer border-2 px-2 py-4 border-[#2965FB] sm:border-none w-full capitalize" onClick={() => btn2Function()} onKeyDown={(e) => { if (e.key === "Enter") btn2Function() }}>{btn2}</button>
                    }

                </div>
            </div>

        </div>
    )
}

export default withOidcSecure(Success)